import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Popover } from 'primeng/popover';
import { ConfigService } from '../../_services/config.service';
import { PortalService } from '../../portale/_services/portal.service';
import { SidebarService } from '../app-sidebar-minimizer/sidebar.service';
import { UserAccessibleRoutesService } from '../../dashboard/_services/user-accessible-routes.service';

@Component({
  standalone: false,
	selector: 'app-sidebar-nav',
	template: ` @if (navLoaded) {
		<nav class="sidebar-nav">
			<ul class="nav" style="cursor: pointer; flex-direction: column">
				@for (navitem of menuItems; track navitem) { @if (isDivider(navitem)) {
				<li class="nav-divider"></li>
				} @if (isTitle(navitem)) {
				<app-sidebar-nav-title [title]="navitem"></app-sidebar-nav-title>
				} @if (!isDivider(navitem) && !isTitle(navitem)) {
				<app-sidebar-nav-item [item]="navitem" routerLinkActive="active"></app-sidebar-nav-item>
				} }
			</ul>
		</nav>
		}`,
})
export class AppSidebarNavComponent implements OnInit {
	currentUser: any = null;
	loginAttivo = false;
	menuItems: any[] = [];
	num_lette: number = 0;
	navLoaded = false;
	// public navigation = navigation;

	public isDivider(item: any) {
		return item.divider ? true : false;
	}

	public isTitle(item: any) {
		return item.title ? true : false;
	}

	constructor(
		private portalservice: PortalService,
		private configService: ConfigService,
		private router: Router,
		private userAccessibleRoutes: UserAccessibleRoutesService,
	) {}

	ngOnInit() {
		this.setLang(this.configService.language);
		this.currentUser = this.configService.getLocalStorageObjectJson('currentUser');
		if (this.currentUser != null) {
			//MI INIZIO 16-06-2023
			if (this.currentUser.usr_primoaccesso === 1) {
				this.router.navigate(['/portale/modpassword', this.currentUser.usr_id]);
				return;
			}
			//MI FINE 16-06-2023

			//const portale = this.configService.getLocalStorageObjectJson('portale');
			this.loginAttivo = true;
			this.portalservice.getMenuItems(this.configService.getPortalID(), this.configService.getCompany_id()).subscribe((menuItems) => {
				this.menuItems = menuItems;
				// Popola la cache delle route accessibili per il filtro permessi del catalog widget
				this.userAccessibleRoutes.loadFromMenu(menuItems);

				const keypage = localStorage.getItem('keypage');
				let primaPag: string = this.menuItems[0].url;
				if (keypage != null && keypage !== undefined) {
					for (let i = 0; i < this.menuItems.length; i++) {
						if (this.menuItems[i].url === keypage) {
							primaPag = keypage;
							localStorage.removeItem('keypage');
							break;
						}
					}
				}
				this.navLoaded = true;
				//this.router.navigate([primaPag]);
			});
		}
	}

	setNotNum(event: any) {
		this.configService.totNot(event);
	}
	setLang(lang: string) {
		//this.translate.use();
	}
}

@Component({
  standalone: false,
	selector: 'app-sidebar-nav-item',
	template: `
		@if (!isDropdown()) {
		  <li [ngClass]="hasClass() ? 'nav-item w-full ' + item.class : 'nav-item w-full'" pTooltip="{{ item.pg_title | translate }}" tooltipPosition="right" [tooltipDisabled]="!minimized || disableTooltip">
		    <app-sidebar-nav-link [link]="item"></app-sidebar-nav-link>
		  </li>
		} @else {
		  <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'" [class.open]="isActive()" routerLinkActive="open" appNavDropdown>
		    <app-sidebar-nav-dropdown [link]="item"></app-sidebar-nav-dropdown>
		  </li>
		}
		`,
})
export class AppSidebarNavItemComponent {
	@Input() item: any;
	@Input() disableTooltip = false;
	minimized = false;

	constructor(private router: Router, private sidebarService: SidebarService) {}

	ngOnInit() {
		this.sidebarService.minimized$.subscribe((min) => (this.minimized = min));
	}

	public hasClass() {
		return this.item.class ? true : false;
	}

	public isDropdown() {
		return this.item.submenu ? true : false;
	}

	public thisUrl() {
		return this.item.url;
	}

	public isActive() {
		if (this.item.url === undefined || this.item.url === null || this.item.url === '' || this.item.url === 'null') {
			return false;
		}
		return this.router.isActive(this.thisUrl(), false);
	}
}

// Submenu text
@Component({
  standalone: false,
	selector: 'app-sidebar-nav-link',
	template: `
		@if (!isExternalLink()) {
		  <a class="pl-1 nav-link nav-dropdown-toggle" (click)="navigateTo(link?.url)" (click)="hideMobile()">
		    @if (isIcon()) {
		      <i class="{{ link?.styleclass }}"></i>
		    }
		    <span>{{ link?.pg_title | translate }}</span>
		    @if (hasDescription()) {
		      <i class="pi pi-info-circle menu-info-icon" pTooltip="{{ link?.pg_description }}" tooltipPosition="right" (click)="$event.stopPropagation()"></i>
		    }
		  </a>
		} @else {
		  <a (click)="navigateTo(link?.url)">
		    @if (isIcon()) {
		      <i class="{{ link?.styleclass }}"></i>
		    }
		    <span>{{ link?.pg_title | translate }}</span>
		    @if (hasDescription()) {
		      <i class="pi pi-info-circle menu-info-icon" pTooltip="{{ link?.pg_description }}" tooltipPosition="right" (click)="$event.stopPropagation()"></i>
		    }
		  </a>
		}
		`,
})
export class AppSidebarNavLinkComponent {
	@Input() link: any;

	public isExternalLink() {
		return this.link?.url && typeof this.link.url === 'string' && this.link.url.substring(0, 4) === 'http';
	}

	public isIcon() {
		return !!this.link?.styleclass;
	}

	public hasDescription() {
		return !!this.link?.pg_description;
	}

	public hideMobile() {
		if (document.body.classList.contains('sidebar-mobile-show')) {
			document.body.classList.toggle('sidebar-mobile-show');
		}
	}

	constructor(private router: Router) {}
	navigateTo(url: any) {
		if (url != null && url != undefined && url != '' && url != 'null') {
			/*KCS MI - pulizia variabili navigazione*/
			sessionStorage.clear();
			/*KCS MI*/
			this.router.navigate(['/' + url]);
		}
	}
}

@Component({
  standalone: false,
	selector: 'app-sidebar-nav-dropdown',
	template: `
		@if (minimized) {
		  <a class="nav-link nav-dropdown-toggle" (mouseenter)="onMouseEnterTrigger($event)" (mouseleave)="onMouseLeaveTrigger()" (click)="navigateTo(link.url, link.pg_id)">
		    @if (isIcon()) {
		      <i class="{{ link.styleclass }}"></i>
		    }
		    <span>{{ link.pg_title | translate }}</span>
		    @if (hasDescription()) {
		      <i class="pi pi-info-circle menu-info-icon" pTooltip="{{ link.pg_description }}" tooltipPosition="right" (click)="$event.stopPropagation()"></i>
		    }
		  </a>
		  <p-popover #op appendTo="body" (onShow)="adjustPosition()" styleClass="menu-popover">
		    <div (mouseenter)="onMouseEnterContent()" (mouseleave)="onMouseLeaveContent()" (click)="op.hide()">
		      <ul class="nav">
		        @for (child of link.submenu; track child) {
		          <app-sidebar-nav-item [item]="child" [disableTooltip]="true"></app-sidebar-nav-item>
		        }
		      </ul>
		    </div>
		  </p-popover>
		} @else {
		  <div class="pre-nav-dropdown-toggle">
		    <a class="nav-link nav-dropdown-toggle" (click)="navigateTo(link.url, link.pg_id);">
		      @if (isIcon()) {
		        <i class="{{ link.styleclass }}"></i>
		      }
		      <span>{{ link.pg_title | translate }}</span>
		      @if (hasDescription()) {
		        <i class="pi pi-info-circle menu-info-icon" pTooltip="{{ link.pg_description }}" tooltipPosition="right" (click)="$event.stopPropagation()"></i>
		      }
		    </a>
		    @if (hasSubMenu()) {
		      <i [ngClass]="'nav-dropdown-toggle-i pi pi-fw pi-angle-' + (submenu ? 'up' : 'down')" (click)="prefToggleDropDown(link.pg_id)"></i>
		    }
		  </div>
		
		  @if (submenu) {
		    <ul class="nav">
		      @for (child of link.submenu; track child) {
		        <app-sidebar-nav-item [item]="child"></app-sidebar-nav-item>
		      }
		    </ul>
		  }
		}
		`,
})
export class AppSidebarNavDropdownComponent implements OnInit {
	@Input() link: any;
	@ViewChild('op') op!: Popover;
	submenu = false;
	minimized = false;
	private hideTimeout: any;

	constructor(private router: Router, private sidebarService: SidebarService) {}

	ngOnInit() {
		this.sidebarService.minimized$.subscribe((min) => (this.minimized = min));
		const storedState = localStorage.getItem(`submenu_${this.link.pg_id}`);
		this.submenu = storedState === 'true';
	}

	adjustPosition() {
		const trigger = this.op.target as HTMLElement;
		const popover = this.op.container as HTMLElement;
		const rect = trigger.getBoundingClientRect();
		popover.style.left = `${rect.right + 12}px`;
		popover.style.top = `${rect.top - 20}px`;
		popover.style.maxWidth = `170px`;
	}

	onMouseEnterTrigger($event: any) {
		clearTimeout(this.hideTimeout);
		this.op.show($event);
	}

	onMouseLeaveTrigger() {
		this.hideTimeout = setTimeout(() => this.op.hide(), 200);
	}

	onMouseEnterContent() {
		clearTimeout(this.hideTimeout);
	}

	onMouseLeaveContent() {
		this.op.hide();
	}

	hasSubMenu() {
		return this.link.submenu && this.link.submenu.length > 0;
	}

	public isIcon() {
		return this.link.styleclass ? true : false;
	}

	public hasDescription() {
		return !!this.link?.pg_description;
	}

	navigateTo(url: any, menu_id: number) {
		if (url != null && url != undefined && url != '' && url != 'null') {
			sessionStorage.clear();
			this.router.navigate(['/' + url]);
			if (document.body.classList.contains('sidebar-mobile-show')) {
				document.body.classList.remove('sidebar-mobile-show');
			}
		}
	}

	prefToggleDropDown(menu_id: number){
		if (this.hasSubMenu()) {
			localStorage.setItem(`submenu_${menu_id}`, this.submenu ? 'false' : 'true');
		}
		this.submenu = !this.submenu; 
	}
}

@Component({
  standalone: false,
	selector: 'app-sidebar-nav-title',
	template: '',
})
export class AppSidebarNavTitleComponent implements OnInit {
	@Input() title: any;

	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngOnInit() {
		const nativeElement: HTMLElement = this.el.nativeElement;
		const li = this.renderer.createElement('li');
		const pg_title = this.renderer.createText(this.title.pg_title);

		this.renderer.addClass(li, 'nav-title');

		if (this.title.class) {
			const classes = this.title.class;
			this.renderer.addClass(li, classes);
		}

		if (this.title.wrapper) {
			const wrapper = this.renderer.createElement(this.title.wrapper.element);

			this.renderer.appendChild(wrapper, pg_title);
			this.renderer.appendChild(li, wrapper);
		} else {
			this.renderer.appendChild(li, pg_title);
		}
		this.renderer.appendChild(nativeElement, li);
	}
}

export const APP_SIDEBAR_NAV = [AppSidebarNavComponent, AppSidebarNavDropdownComponent, AppSidebarNavItemComponent, AppSidebarNavLinkComponent, AppSidebarNavTitleComponent];
